module.exports = require('./helpers/bundle-url').getBundleURL('7v8lJ') + "logo.c51670a8.svg";